import React, { useContext, useEffect, useState } from "react";
import { FaSearch } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import AlertContext from "../../../../Context/Alert/AlertContext";
import axios from "axios";
import { BaseURL } from "../../../../Files/BaseURL";
import { formatDateForInput } from "../../../../Files/UseFunction";
import ThemeContext from "../../../../Context/theme/ThemeContext";

const Recived = () => {
  const navigate = useNavigate();
  const { theme } = useContext(ThemeContext);
  const { showAlert } = useContext(AlertContext);

  const [offers, setOffers] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [totalOffers, setTotalOffers] = useState(0);

  // Function to fetch offers based on selected status and search term
  const fetchOffers = async (page = currentPage) => {
    try {
      setLoading(true);
      const authToken = localStorage.getItem("p@token");
      const response = await axios.get(
        `${BaseURL}/api/getoffer/getrecivedoffer`,
        {
          headers: {
            "auth-token": authToken,
          },
          params: {
            status: selectedStatus,
            search: searchTerm,
            page: page,
            limit: itemsPerPage,
          },
        }
      );

      if (response.data.success) {
        setOffers(response.data.offers);
        setTotalPages(response.data.pagination.totalPages);
        setTotalOffers(response.data.pagination.totalOffers);
      } else {
        showAlert(response.data.message, "danger");
      }
    } catch (error) {
      showAlert("Internal Server Error", "danger");
    } finally {
      setLoading(false);
    }
  };

  // Fetch offers when component mounts, status changes, or search term changes
  useEffect(() => {
    setCurrentPage(1); // Reset to first page when filters change
    fetchOffers(1);
  }, [selectedStatus, searchTerm, itemsPerPage]);

  // Fetch offers when page changes
  useEffect(() => {
    fetchOffers(currentPage);
  }, [currentPage]);

  // Handle page change
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  // Handle items per page change
  const handleItemsPerPageChange = (newLimit) => {
    setItemsPerPage(newLimit);
    setCurrentPage(1); // Reset to first page when limit changes
  };

  return (
    <div className="w-full">
      <div className="flex flex-col gap-4 lg:flex-row justify-between font-pop lg:items-center">
        <div className="flex gap-2 md:gap-6 items-center">
          <h3
            className={` text-sm md:text-lg font-medium ${
              theme == "dark" && " text-white"
            }`}
          >
            Total {offers?.length} Offers
          </h3>
          <div
            className={`  rounded-2xl px-1 md:px-3 ${
              theme == "dark" ? "bg-black text-white" : "bg-gray-300 "
            }`}
          >
            <select
              name=""
              id=""
              value={selectedStatus} // Bind value to selectedStatus
              onChange={(e) => setSelectedStatus(e.target.value)} // Handle change
              className={`border-none outline-none 
                          focus:outline-none focus:border-none focus:outline-transparent
                          active:border-none active:outline-none text-sm md:text-lg font-normal
                  ${theme == "dark" ? "bg-black text-white" : "bg-gray-300"}`}
            >
              <option value="">All Offers</option>
              <option value="New">New</option>
              <option value="In progress">In progress</option>
              <option value="Delivered">Delivered</option>
              <option value="Completed">Completed</option>
              <option value="Under review">Under review</option>
              <option value="Declined">Declined</option>
            </select>
          </div>
        </div>
        <div
          className={`flex gap-3 items-center rounded-full py-1 px-4     ${
            theme == "dark" ? "bg-black text-white" : "bg-gray-300 "
          }`}
        >
          <FaSearch className="text-gray-400 text-lg md:text-2xl" />
          <input
            type="text"
            placeholder="Search..."
            className="bg-transparent text-sm md:text-lg border-none outline-none focus:outline-none focus:border-none active:outline-none "
            value={searchTerm} // Bind value to searchTerm
            onChange={(e) => setSearchTerm(e.target.value)} // Handle search input change
          />
        </div>
      </div>
      {loading ? (
        <div className="text-center py-8">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primarygreen mx-auto"></div>
        </div>
      ) : (
        <>
          <div className="overflow-x-scroll font-pop w-full my-2 md:my-6">
            <table className="max-w-full w-full overflow-x-scroll border-spacing-y-4 border-separate">
              <thead>
                <tr>
                  <th
                    scope="col"
                    className={`px-2 md:px-6 py-1 md:py-3 text-left font-medium uppercase ${
                      theme == "dark" && " text-white"
                    }`}
                  >
                    Status
                  </th>
                  <th
                    scope="col"
                    className={`px-2 md:px-6 py-1 md:py-3 text-left w-[30%] font-medium  uppercase ${
                      theme == "dark" && "b text-white"
                    }`}
                  >
                    Title
                  </th>
                  <th
                    scope="col"
                    className={`px-2 md:px-6 py-1 md:py-3 text-left font-medium uppercase ${
                      theme == "dark" && " text-white"
                    }`}
                  >
                    Type
                  </th>
                  <th
                    scope="col"
                    className={`px-2 md:px-6 py-1 md:py-3 text-left font-medium uppercase ${
                      theme == "dark" && " text-white"
                    } `}
                  >
                    Price
                  </th>
                  <th
                    scope="col"
                    className={`px-2 md:px-6 py-1 md:py-3 text-left font-medium  uppercase ${
                      theme == "dark" && " text-white"
                    }`}
                  >
                    User
                  </th>
                  <th
                    scope="col"
                    className={`px-2 md:px-6 py-1 md:py-3 text-left font-medium  uppercase ${
                      theme == "dark" && "text-white"
                    }`}
                  >
                    Date
                  </th>
                </tr>
              </thead>
              <tbody>
                {offers?.map((item, index) => (
                  <tr
                    className="cursor-pointer"
                    onClick={() => {
                      navigate(
                        `/user-dashboard/offers/recivedchat/${item._id}`
                      );
                    }}
                    key={index}
                  >
                    <td
                      className={`px-2 md:px-6 rounded-l-2xl text-sm md:text-base  my-3 py-3 text-left ${
                        theme == "dark" ? "bg-black text-white" : "bg-white "
                      }`}
                    >
                      <div
                        className={`
                          py-2 px-4 rounded-lg border-2 w-max font-medium
                          ${
                            item?.Status === "New"
                              ? "bg-[#8A39F2]/30 border-[#8A39F2] text-[#8A39F2]"
                              : item?.Status === "In progress"
                              ? "bg-[#EBF4FE] border-[#3992F2] text-[#3992F2]"
                              : item?.Status === "Delivered"
                              ? "bg-[#FCEBFE] border-[#E339F2] text-[#E339F2]"
                              : item?.Status === "Completed"
                              ? "bg-[#EFFBF1] border-[#63D577] text-[#63D577]"
                              : item?.Status === "Under review"
                              ? "bg-[#FEF8EE] border-[#F9B754] text-[#F9B754]"
                              : "bg-[#FCEBEC] border-[#DD3242] text-[#DD3242]"
                          }
                        `}
                      >
                        {item?.Status}
                      </div>
                    </td>
                    <td
                      className={`px-2 md:px-6 my-3 text-base md:text-lg font-semibold py-3 text-left w-max min-w-[30%]
                        ${
                          theme == "dark" ? "bg-black text-white" : "bg-white "
                        }`}
                    >
                      <h2 className="w-max">{item?.Title}</h2>
                    </td>
                    <td
                      className={`px-2 md:px-6  my-3 py-1 md:py-3 font-normal text-left
                        ${
                          theme == "dark" ? "bg-black text-white" : "bg-white "
                        }`}
                    >
                      <h2 className="w-max">{item?.Type}</h2>
                    </td>
                    <td
                      className={`px-2 md:px-6  my-3 py-1 md:py-3 text-left font-semibold
                        ${
                          theme == "dark" ? "bg-black text-white" : "bg-white "
                        } `}
                    >
                      <h2 className="w-max">${item?.Price}</h2>
                    </td>
                    <td
                      className={`px-2 md:px-6  my-3 py-1 md:py-3 text-left 
                        ${
                          theme == "dark" ? "bg-black text-white" : "bg-white "
                        }`}
                    >
                      <div className="flex font-medium flex-row gap-2 items-center">
                        {item?.Seller?.ProfilePhoto ? (
                          <img
                            src={item?.Seller?.ProfilePhoto}
                            alt=""
                            className="rounded-full w-8 md:w-12 h-8 md:h-12"
                          />
                        ) : (
                          <div
                            className={`w-8 md:w-12 h-8 md:h-12 rounded-full font-pop bg-gray-400 flex items-center justify-center
                            ${theme == "dark" && "bg-black text-white"}`}
                          >
                            <span className="text-white">
                              {item?.Seller &&
                                item?.Seller?.FirstName?.charAt(0)}
                            </span>
                          </div>
                        )}
                        <h2 className="w-max">
                          {item?.Seller?.FirstName} {item?.Seller?.LastName}
                        </h2>
                      </div>
                    </td>
                    <td
                      className={`px-2 md:px-6 rounded-r-2xl text-gray-400  my-3 py-1 md:py-3 text-left 
                        ${
                          theme == "dark" ? "bg-black text-white" : "bg-white "
                        }`}
                    >
                      <h2 className="w-max">
                        {formatDateForInput(item.Delivery)}
                      </h2>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {offers?.length > 0 && (
            <div className="flex items-center justify-between border-t border-gray-200 px-4 py-3 sm:px-6 mt-4 rounded-lg">
              <div className="flex flex-1 justify-between sm:hidden">
                {/* Mobile view */}
                <button
                  onClick={() => handlePageChange(Math.max(currentPage - 1, 1))}
                  disabled={currentPage === 1}
                  className={`relative inline-flex items-center px-4 py-2 text-sm font-semibold ${
                    currentPage === 1
                      ? "bg-gray-100 text-gray-400"
                      : "bg-white text-gray-700 hover:bg-gray-50"
                  } ring-1 ring-inset ring-gray-300 rounded-md`}
                >
                  Previous
                </button>
                <button
                  onClick={() =>
                    handlePageChange(Math.min(currentPage + 1, totalPages))
                  }
                  disabled={currentPage === totalPages}
                  className={`relative ml-3 inline-flex items-center px-4 py-2 text-sm font-semibold ${
                    currentPage === totalPages
                      ? "bg-gray-100 text-gray-400"
                      : "bg-white text-gray-700 hover:bg-gray-50"
                  } ring-1 ring-inset ring-gray-300 rounded-md`}
                >
                  Next
                </button>
              </div>

              {/* Desktop view */}
              <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
                {/* Left side - Items per page */}
                <div>
                  <div className="flex items-center gap-4 font-bold font-pop text-xs">
                    <select
                      value={itemsPerPage}
                      onChange={(e) =>
                        handleItemsPerPageChange(Number(e.target.value))
                      }
                      className="block w-20 rounded-md border-0 py-1.5 pl-3 pr-8 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-primarygreen sm:text-sm sm:leading-6"
                    >
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                    </select>
                    <p className="text-sm text-gray-700">items per page</p>
                  </div>
                </div>

                {/* Center - Items count */}
                <div className="font-pop text-xs font-bold">
                  <p className="text-sm text-gray-700">
                    {`${(currentPage - 1) * itemsPerPage + 1}-${Math.min(
                      currentPage * itemsPerPage,
                      totalOffers
                    )} of ${totalOffers} items`}
                  </p>
                </div>

                {/* Right side - Navigation and pages */}
                <div className="flex items-center gap-4 font-bold font-pop text-xs">
                  <div className="flex items-center gap-2">
                    <p className="text-sm text-gray-700">Page</p>
                    <p className="text-sm font-bold text-gray-900">
                      {currentPage}
                    </p>
                    <p className="text-sm text-gray-700">of</p>
                    <p className="text-sm font-bold text-gray-900">
                      {totalPages}
                    </p>
                    <p className="text-sm text-gray-700">pages</p>
                  </div>
                  <nav
                    className="isolate inline-flex -space-x-px rounded-md shadow-sm"
                    aria-label="Pagination"
                  >
                    <button
                      onClick={() =>
                        handlePageChange(Math.max(currentPage - 1, 1))
                      }
                      disabled={currentPage === 1}
                      className={`relative inline-flex items-center rounded-l-md px-2 py-2 ${
                        currentPage === 1
                          ? "bg-gray-100 text-gray-400"
                          : "bg-white text-gray-500 hover:bg-gray-50"
                      } ring-1 ring-inset ring-gray-300 focus:z-20 focus:outline-offset-0`}
                    >
                      <span className="sr-only">Previous</span>
                      <svg
                        className="h-5 w-5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          fillRule="evenodd"
                          d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </button>

                    <button
                      onClick={() =>
                        handlePageChange(Math.min(currentPage + 1, totalPages))
                      }
                      disabled={currentPage === totalPages}
                      className={`relative inline-flex items-center rounded-r-md px-2 py-2 ${
                        currentPage === totalPages
                          ? "bg-gray-100 text-gray-400"
                          : "bg-white text-gray-500 hover:bg-gray-50"
                      } ring-1 ring-inset ring-gray-300 focus:z-20 focus:outline-offset-0`}
                    >
                      <span className="sr-only">Next</span>
                      <svg
                        className="h-5 w-5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          fillRule="evenodd"
                          d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </button>
                  </nav>
                </div>
              </div>
            </div>
          )}

          {offers.length === 0 && (
            <div className="text-center py-4 font-pop text-lg font-medium">
              No offers found
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Recived;
